// Mori — public URLs for the two-domain split.
//
// APP_URL       → the PWA at app.meetmori.app (auth, captures, settings, redeem flows).
// MARKETING_URL → the landing site at meetmori.app (sign-up funnels, marketing pages).
//
// Configure per environment via Vite env vars:
//   VITE_APP_URL=https://app.meetmori.app
//   VITE_MARKETING_URL=https://meetmori.app
//
// Defaults assume production. Override in .env.local for previews/staging.

export const APP_URL: string =
  (import.meta.env.VITE_APP_URL as string | undefined) ?? "https://app.meetmori.app";

export const MARKETING_URL: string =
  (import.meta.env.VITE_MARKETING_URL as string | undefined) ?? "https://meetmori.app";
